import { gql } from '@apollo/client';
import { WAREHOUSE_FIELDS } from '../../../../../graphql/types/WarehouseType';

export const GET_HUB_AND_WAREHOUSES_FOR_SITE_MANAGEMENT = gql`
    query GetHubAndWarehousesForSiteManagement {
        warehouses: getHubAndWarehousesForSiteManagement {
            ...WarehouseFields
        }
    }
    ${WAREHOUSE_FIELDS}
`;
